import React from 'react';
import { useSnackbar } from './useSnackbar';
import { SnackbarContainer } from './style';

function Snackbar({ fixed = 'false', elevate = false }) {
  const { toggleSnack, snackText, snackType, snackAction, setToggleSnack } = useSnackbar();

  return (
    <SnackbarContainer
      type={snackType}
      className={toggleSnack ? `isActive` : ``}
      onClick={() => setToggleSnack(false)}
      fixed={fixed}
      toggleSnack={toggleSnack}
      isLong={snackAction.length > 10}
      elevate={elevate}
    >
      <div>{snackText}</div>
      <span>{snackAction}</span>
    </SnackbarContainer>
  );
}

export { Snackbar };
